export default "__VITE_ASSET__CzUQ5jdT__"